import { IRootState, RootState } from '../root-state.store';
// @ts-ignore
import { IOwnerService, OwnerService } from '@/services';
// @ts-ignore
import { ActivityStatus } from '@/common/enums';

export interface IOwnerState extends IRootState<IOwnerService> {
  owners?: any[];
  currentOwner?: any;
}

export class OwnerState extends RootState<IOwnerService> implements IOwnerState {
  /**
   *
   */
  owners?: any[];
  currentOwner?: any;

  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new OwnerService;
    this.owners = [];
    this.currentOwner = {
      tenants: [],
      owners: [],
      address: {},
      caretakers: []
    };
  }
}


// WEBPACK FOOTER //
// ./src/store/owner/owner-state.store.ts